module.exports = __webpack_public_path__ + "static/media/calendar-icon.1afa8e5a.svg";